<template>
  <span>
    <button type="button" class="ee-icon-btn" :aria-label="tm('notifications', 'Notifications')" @click="open = true">
      <span class="material-symbols-outlined">notifications</span>
      <span class="ee-icon-btn__badge" :class="{ 'is-on': count > 0 }">{{ count }}</span>
    </button>

    <v-bottom-sheet v-model="open" scrollable max-width="560">
      <div class="ee-sheet">
        <div class="ee-more__grab" />
        <div class="ee-sheet__head">
          <div style="flex: 1">
            <h2 class="ee-sheet__title">{{ tm('notifications', 'Notifications') }}</h2>
            <div class="ee-muted">{{ tm('n_unread', '{n} unread', { n: count }) }}</div>
          </div>
          <button type="button" class="ee-sheet__close" :aria-label="tm('close', 'Close')" @click="open = false">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>

        <div v-if="!items.length" class="ee-empty" style="padding: 30px 10px">
          <span class="ee-empty__ic"><span class="material-symbols-outlined">notifications</span></span>
          <h3>{{ tm('no_notifications', 'No notifications') }}</h3>
          <p>{{ $t('notifications.you_have_no_notifications') }}</p>
        </div>

        <div v-else class="ee-notif-list">
          <button
            v-for="item in items"
            :key="item.key"
            type="button"
            class="ee-notif"
            :class="{ 'is-unread': item.unread }"
            @click="go(item)"
          >
            <span class="ee-notif__ico"><span class="material-symbols-outlined">{{ item.icon }}</span></span>
            <span class="ee-notif__txt">
              <span class="ee-notif__t1">{{ item.title }}</span>
              <span class="ee-notif__t2">{{ item.body }}</span>
            </span>
            <time v-if="item.time">{{ item.time }}</time>
          </button>
        </div>

        <button v-if="unreadMessagesCount" type="button" class="ee-btn ee-btn--ghost ee-btn--block" style="margin-top: 14px" @click="markAll">
          <span class="material-symbols-outlined">done_all</span>{{ tm('mark_all_read', 'Mark all as read') }}
        </button>
      </div>
    </v-bottom-sheet>
  </span>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import navigateMixin from '../../mixins/navigate'
import i18nMixin from '../../modern/i18n'
import { relativeTime } from '../../modern/time'

// Notification centre: the latest announcements (newsfeed) + unread networking messages.
export default {
  mixins: [navigateMixin, i18nMixin],

  data () {
    return { open: false }
  },

  computed: {
    ...mapGetters(['messages', 'messagesRead', 'unreadMessagesCount', 'unreadNetworkingMessagesIds']),
    ...mapState('common', ['menu']),

    newsItem () {
      return this.menu.find(item => item.module === 'messages')
    },

    networkingItem () {
      return this.menu.find(item => item.module === 'networking')
    },

    count () {
      return (this.newsItem ? this.unreadMessagesCount : 0) + (this.networkingItem ? this.unreadNetworkingMessagesIds.length : 0)
    },

    items () {
      const items = []
      if (this.networkingItem && this.unreadNetworkingMessagesIds.length) {
        const n = this.unreadNetworkingMessagesIds.length
        items.push({
          key: 'networking',
          icon: 'forum',
          title: this.networkingItem.name,
          body: this.$tc('notifications.you_have_x_unread_network_messages', n, { n }),
          unread: true,
          to: this.networkingItem,
        })
      }
      if (this.newsItem) {
        this.messages.slice(0, 10).forEach(message => {
          items.push({
            key: `m${message.id}`,
            icon: 'campaign',
            title: this.newsItem.name,
            body: (message.text || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim(),
            time: relativeTime(this, message.sent_at),
            unread: !this.messagesRead.includes(message.id),
            to: this.newsItem,
          })
        })
      }
      return items
    },
  },

  methods: {
    ...mapActions(['saveReadMessages']),

    go (item) {
      this.open = false
      this.navigateTo(item.to)
    },

    markAll () {
      this.saveReadMessages()
      this.$root.$emit('ee-snack', { text: this.tm('all_caught_up', "You're all caught up") })
    },
  },
}
</script>
